<script setup lang="ts">
import type { Props } from './types';

const props = withDefaults(defineProps<Props>(), {
	gap: 'none',
});
</script>

<template>
	<div
		:class="{
			['top-rows']: true,
			['top-rows-gap_' + props.gap]: true,
		}"
	>
		<slot></slot>
	</div>
</template>

<style>
.top-rows {
	display: flex;
	flex-direction: column;
	flex-grow: 1;
}

.top-rows-gap_none {
	gap: 0px;
}

.top-rows-gap_xs {
	gap: var(--top-gap-1);
}

.top-rows-gap_s {
	gap: var(--top-gap-2);
}

.top-rows-gap_m {
	gap: var(--top-gap-3);
}

.top-rows-gap_l {
	gap: var(--top-gap-4);
}
</style>
